import { COVERAGE_STATUS } from 'constants/common';

/**
 * @type {function}
 * @desc Return member icon color based on coverage status and member relationship.
 * A resolver function takes an `id` and an optional `payload` and returns a `result`.
 * Based on `switch` cases inside this function, correct `result` should be returned.
 * @param {object} payload
 * @example
 * import { getMemberIconColor } from 'resolvers/hipaaAndCoverage';
 */
export const getMemberIconColor = ( { isActive, coverageStatus } = {} ) => {

    // if member is active (whose information is currently being displayed)
    if( isActive ) {
        return THEME.themeColorPrimary2; // from theme
    }

    // return color based on `authorized` value
    return COVERAGE_STATUS.ACTIVE === coverageStatus ? '#59ad00': '#e51a1a';
};
